// import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS } from '@/shared';
import { useGetATS } from '@/shared/actions/erp';
import { useCheckPermissions, useLoaders } from '@/shared/hooks';
// import { AlertSeverityEnum } from '@/shared/interfaces';
// import { useUiStore } from '@/store/ui';
import { SaveATS } from '../../shared/components';
import { toast } from 'react-toastify';

export type ATSContainerPageProps = {};

const ATSContainerPage: React.FC<
  ATSContainerPageProps
> = () => {
  const returnUrlATSTecnicoPage = ROUTER_PATHS.tecnico.atsNav;
  useCheckPermissions(PermissionsEnum.api_change_analisistrabajoseguro);


  const { id } = useParams();
  const { data, isLoading } = useGetATS(id!);
  useLoaders( isLoading );

  if ( isLoading ) return null;
  if (!data?.data?.id_analisis_trabajo_seguro)
    return <Navigate to={returnUrlATSTecnicoPage} />;
  if(data.data.completado && !data.data.solicita_formato_fisico){
    toast.error("El ATS ya se encuentra completado");
    return <Navigate to={returnUrlATSTecnicoPage} />;
  }

  return (
    <SaveATS
      title={`Análisis de Trabajo Seguro`}
      atsdata={data.data}
    />
  );
};

export default ATSContainerPage;
